module.exports = __webpack_public_path__ + "img/my_icon.ee503c5b.jpeg";